import React from 'react';
import { getCheckoutSelectionPlans } from '@/lib/parent-plan-catalog';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/components/ui/card';
import { Button } from '@/components/components/ui/button';
import Image from 'next/image';
const CheckoutScreen2 = ({ nextStage, setParentPlan }) => {
    const parentPlans = getCheckoutSelectionPlans();
    const createNewPlans = () => {
        return (
            <>
                {parentPlans.map((plan, index) => {
                    return (
                        <Card
                            key={plan.id}
                            className={`relative ${plan.background} bg-cover bg-no-repeat rounded-3xl md:rounded-xl text-black w-full h-full flex flex-col max-w-full md:max-w-[369px] py-5`}
                        >
                            {index === 2 && (
                                <div className='absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-20 flex items-center justify-center'>
                                    <div className='relative w-[150px] md:w-[180px] h-[150px] md:h-[180px]'>
                                        <Image src='/assets/homepageV2/Pricing/BestValue.png' alt='Best value badge' fill className='object-contain' />
                                    </div>
                                    <span className='absolute text-white font-medium text-base md:text-lg'>Best value</span>
                                </div>
                            )}
                            <CardHeader className=' p-0 sm:p-6 pt-5 sm:pt-6 pb-2 sm:pb-6 space-y-0'>
                                <CardTitle
                                    className='text-[28px] sm:text-[40px] leading-8 sm:leading-[46px] font-semibold text-center mx-auto'
                                    style={index === 0 ? { maxWidth: '80%' } : {}}
                                >
                                    {plan.name}
                                </CardTitle>
                                <div className='text-[34px] sm:text-[60px] font-semibold text-center leading-[100%]'>{plan.price}</div>
                                <div className='text-[22px] sm:text-[37px] font-normal text-center leading-[100%] mt-3'>{plan.duration}</div>
                            </CardHeader>
                            <CardContent className='h-full px-8 md:px-6 pb-4 xl:pb-7 pt-0'>
                                <div className='space-y-3 mt-2'>
                                    {plan.bullets?.map((bullet, bulletIndex) => (
                                            <div key={bulletIndex} className='flex items-start px-4 '>
                                                <svg
                                                    className='w-5 h-5 text-[#5F42CD] mr-2 flex-shrink-0 mt-0.5'
                                                    fill='currentColor'
                                                    viewBox='0 0 20 20'
                                                    xmlns='http://www.w3.org/2000/svg'
                                                >
                                                    <path
                                                        fillRule='evenodd'
                                                        d='M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z'
                                                        clipRule='evenodd'
                                                    ></path>
                                                </svg>
                                                <span className='text-lg leading-[130%]'>{bullet}</span>
                                            </div>
                                        ))}
                                </div>
                            </CardContent>

                            <div className='flex justify-center pb-0'>
                                <Button
                                    onClick={() => {
                                        nextStage({ stage: 1 });
                                        setParentPlan(plan.checkoutIndex);
                                    }}
                                    className='font-normal rounded-[50px] text-lg px-6 sm:px-10 py-7 sm:py-7 border-none bg-[#5F42CD] text-white transition-all duration-300 ease-in-out hover:bg-[#342274]'
                                >
                                    Start Free Trial
                                </Button>
                            </div>
                        </Card>
                    );
                })}
            </>
        );
    };

    return (
        <div className='relative'>
            {/* blur effect pink */}
            <div className='hidden md:block absolute top-[-50px] right-0 rounded-full opacity-[1.4] bg-[#B031FA] bg-opacity-[0.7] blur-[250px] w-[729px] h-[585px] z-[1]' />
            {/* blur effect dark purple */}
            <div className='hidden md:block absolute bottom-[-190px] left-0 rounded-full opacity-[1.4] bg-[#161042] bg-opacity-[0.7] blur-[250px] w-[729px] h-[585px] z-[1]' />

            <div className='font-Poppins relative z-10'>
                <div className='mx-auto max-w-[930px] text-[28px] sm:text-[40px] font-semibold text-center mt-6 sm:mt-12 px-10 lg:px-0 leading-snug text-white'>
                    Unlock Math Success with a Free 7-Day Trial
                    {/*Choose a plan and upgrade now to keep achieving!*/}
                </div>
                <div className='text-center text-white text-lg sm:text-2xl mt-1 px-4'>See results in one week. Easy to cancel before you're charged.</div>
                <div className='mx-auto max-w-[1200px] mt-4 sm:mt-8 md:mt-16 md:px-6'>
                    {/* Blue box with lightbulb */}
                    <div className='w-full mt-12 mb-8  mx-auto'>
                        <div className='bg-[#0c1b32] bg-opacity-60 rounded-none md:rounded-3xl p-6 md:p-8 py-12 md:py-8  text-white'>
                            <div className=' flex flex-col-reverse md:flex-row gap-9 lg:gap-12 justify-center items-stretch'>{createNewPlans()}</div>
                            {/* Desktop Info Onbottom */}

                            <div className='flex-1 text-center md:text-left mt-10 md:mt-[50px]'>
                                <div className='text-2xl md:text-[30px] lg:text-[38px] mb-2 hidden md:flex justify-center items-center'>
                                    <div className='relative w-[50px] md:w-[40px] h-[50px] md:h-[40px] flex-shrink-0 mb-4 md:mb-0'>
                                        <Image src='/assets/homepageV2/Pricing/lightbulb1.png' alt='Lightbulb icon' fill className='object-contain' />
                                    </div>
                                    <div className=' text-left md:text-center'>Exceptional value. Exceptional Results</div>
                                </div>
                                {/* Mobile Header */}
                                <div className='text-2xl text-left block md:hidden max-w-[240px] mb-4'>Exceptional value. Exceptional Results</div>

                                <div className='text-xl text-left md:text-center hidden md:block '>
                                    Traditional math tutoring is expensive. Unlock math achievement at a fraction of the cost.{' '}
                                </div>
                                <div className='text-xl text-left md:text-center block md:hidden'>Unlock math achievement at a fraction of the cost. </div>
                                {/*  items info */}
                                <div className='mt-4 md:mt-8 flex flex-col md:flex-row gap-4 rounded-xl max-w-[1000px] mx-auto text-xl leading-[130%]'>
                                    {/* Private Math Tutors */}
                                    <div className='text-left lg:p-4 flex-1'>
                                        <div className='font-semibold'>Private Math Tutors</div>
                                        <div className=''>Hourly Rate: $40-$100</div>
                                        <div className='text-[#FF6B6B] font-medium'>Over $7,000/year</div>
                                    </div>

                                    {/* Divider 1 */}
                                    <div className='hidden w-px bg-gray-200/30 my-4'></div>

                                    {/* Math Tutoring Centers */}
                                    <div className='text-left lg:p-4 flex-1'>
                                        <div className='font-semibold'>Math Tutoring Centers</div>
                                        <div>Monthly Rate: $250-$500</div>
                                        <div className='text-[#FF6B6B] font-medium'>Over $4,000/year</div>
                                    </div>

                                    {/* Divider 2 */}
                                    <div className='hidden md:block w-0.5 bg-gray-200/30 mb-10 mt-4'></div>

                                    {/* Muzology's Plan */}
                                    <div className='text-left lg:p-4 flex-1'>
                                        <div className=''>
                                            <span className='font-semibold'>Muzology's Complete Math Mastery plan </span>delivers UNLIMITED math
                                            learning--anytime, anywhere for the equivalent of just <span className='text-[#FFD720]'>$9.16 a month!</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CheckoutScreen2;
